import type { SetupFilter } from '../filter'
import { ListTypes, type Pagination } from '../index'
import { handleGetDraft } from './handleGetDraft'
import { handleGetMine } from './handleGetMine'
import { handleGetPublished } from './handleGetPublished'
import { handleGetSubscribed } from './handleGetSubscribed'
import { handleGetTaken } from './handleGetTaken'

type FetchParams = {
  listType: ListTypes
  filters: SetupFilter
  pagination: Pagination
  userId?: string
}

export const fetchSetupsRouter = async (params: FetchParams) => {
  // Wait for auth to initialize before making non-public queries
  if (!params.userId && params.listType !== ListTypes.published) {
    return []
  }

  switch (params.listType) {
    case ListTypes.published:
      return handleGetPublished(params)
    case ListTypes.taken:
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      return handleGetTaken(params as any)
    case ListTypes.subscribed:
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      return handleGetSubscribed(params as any)
    case ListTypes.mine:
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      return handleGetMine(params as any)
    case ListTypes.draft:
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      return handleGetDraft(params as any)
    default:
      return []
  }
}
